import O from "./O";
import * as Contexts from './Contexts';
import * as DragContexts from './MouseDragProvider';
import { useContext } from 'react';
import { useState } from 'react';

function ContextView({name,context}){

  

  const cc = useContext(context);

  if( name === "CropAdjustmentContext" ){
    //console.log({[name]:cc});
  }

  if( !cc ){
    return null;
  }

  if( Object.keys(cc).length === 0 ){
    return null;
  }


  let truthyValues = Object.values(cc).filter(x => x);

  if( truthyValues.every(x => x instanceof Function) ){
    return null;
  }


  

  return (
    <div style={{
      background:'black',
    }} class="fair-padding">

      <div><O>{cc}</O></div>
      <div>{name}</div>
      
    </div>
  )

}



export default function ContextTrace(){


  const [ hide, setHidden ] = useState(
    JSON.parse(localStorage.getItem("hideContextDebug"))
  );

  let allEntries = [ DragContexts, Contexts ].flatMap(Object.entries).sort((a,b) => a[0]?.localeCompare(b[0]));
  //let x = Contexts;
  let contextViews = allEntries.map(([name,context]) => {
    return (
      <ContextView name={name} context={context}/>
    )
  })

  //let hide = localStorage.getItem("hideContextDebug");

  if( process.env.NODE_ENV === "development" ){

    return false && (

      <div onClick={e => {
        e.stopPropagation();
      }} class="sg-row" style={{
        alignItems:'end',
        color:'lime',
        fontFamily:"Monospace",
        position:'fixed',
        bottom:0,
        left:0,
        overflow:'visible',
        zIndex:99999999,
        pointerEvents:'none',
      }}>
        <div style={{background:'#ccc',color:'black'}}>
          <div>
            {allEntries.map(x => <div>{x[0]}</div>)}
          </div>

          <button style={{
            pointerEvents:'auto',
          }} onMouseDown={e => e.stopPropagation()}
            onMouseUp={e => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();

              setHidden(!hide)
              localStorage.setItem("hideContextDebug",!hide)

            }}>Toggle Context Trace</button>
        </div>
        {!hide && contextViews}

      </div>
    )
  }

  return null;
}
